import React from "react";
// WalletConnect
import {
  EthereumClient,
  w3mConnectors,
  w3mProvider,
} from "@web3modal/ethereum";
import { Web3Modal } from "@web3modal/react";
import { ExplorerCtrl } from '@web3modal/core';
import { configureChains, createConfig, WagmiConfig } from "wagmi";
import { publicProvider } from "wagmi/providers/public";
import { NETWORK_SPECIFICATION, PROJECT_ID } from "../constants";

const chains = [NETWORK_SPECIFICATION];
const projectId = PROJECT_ID;

const keywordkey = 'injectedWallets'; 
ExplorerCtrl.state.walletInfos = null;
Object.defineProperty(ExplorerCtrl.state, keywordkey, {
  get() {
    return this.walletInfos?.filter(({ injected }) => injected !== undefined && injected !== null);
  },
  set(value) {
    this.walletInfos = value;
  },
});

const { publicClient } = configureChains(chains, [
  w3mProvider({ projectId }),
  publicProvider(),
]);

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: navigator.userAgent != "ReactSnap" ? w3mConnectors({ projectId, version: 2, chains }) : undefined,
  publicClient,
});
const ethereumClient = new EthereumClient(wagmiConfig, chains);

const WalletConnector = ({ children }) => {
  return (
    <WagmiConfig config={wagmiConfig}>
      {children}
      {/* Header z-index is 100 */}
      <Web3Modal
        defaultChain={NETWORK_SPECIFICATION}
        projectId={projectId}
        ethereumClient={ethereumClient}
        themeVariables={{ "--w3m-z-index": 101 }}
      />
    </WagmiConfig>
  );
};

export default WalletConnector;
